module.exports = __webpack_public_path__ + "assets/img/Plakat1.5272e62d.png";